<template>
<div class="yandex-map-component">
  <div class="yandex-map-container" :id="containerId"></div>
</div>
</template>

<script>
import get from 'lodash/get'
import config from '@/config'

export default {
  $ymap: null,

  props: {
    center: {
      type: Array,
      required: true,
    },

    zoom: {
      type: Number,
      required: false,
      default: 12,
    },

    placemarks: {
      type: Array,
      required: false,
      default: () => [],
    },

    zones: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  created() {
    if (!this.scriptAttached()) {
      this.attachScript()
    } else {
      this.scriptLoaded()
    }
  },

  computed: {
    apiKey() {
      return get(config, 'services.yandex.key')
    }
  },

  methods: {
    scriptAttached() {
      const el = document.getElementById(this.scriptId)

      return el && el.length !== 0
    },

    attachScript() {
      if (this.scriptAttached()) {
        return
      }

      const script = document.createElement('script')
      script.src = `https://api-maps.yandex.ru/2.1/?apikey=${this.apiKey}&lang=ru_RU`
      script.id = this.scriptId
      script.onload = () => this.scriptLoaded()

      document.getElementsByTagName('head')[0].appendChild(script)
    },

    scriptLoaded() {
      ymaps.ready(() => {
        this.$ymap = new ymaps.Map(this.containerId, {
          behaviors: ['drag'],
          center: this.center,
          zoom: this.zoom,
          controls: [],
        })

        this.$ymap.controls.add('zoomControl', {
          position: {
            left: '15px',
            top: '100px',
          },
        })

        if (this.placemarks.length > 0) {
          this.addPlacemarks()
        }

        if (this.zones.length > 0) {
          this.addZones()
        }
      })
    },

    addPlacemarks() {
      this.placemarks.forEach(placemark => {
        this.$ymap.geoObjects.add(new ymaps.Placemark(placemark.coords, {
          balloonContent: placemark.text,
        }, {
          preset: 'islands#dotIcon',
          iconColor: 'red',
        }))
      })
    },

    addZones() {
      this.zones.forEach(zone => {
        const polygon = new window.ymaps.Polygon(
          [
            zone.coordinates.map(({latitude, longitude}) => [latitude, longitude])
          ],
          {
            id: zone.id,
            hintContent: zone.html,
          },
          {
            fillColor: zone.color || '#00FF00',
            strokeColor: '#0000FF',
            strokeWidth: 2,
            opacity: 0.3,
          }
        );

        this.$ymap.geoObjects.add(polygon);
      })
    },
  },

  data() {
    return {
      scriptId: 'yandex-maps-api-script',
      containerId: `yandex-maps-container-${Math.random().toString().replace('.', '_')}`,
    }
  }
}
</script>

<style lang="less">
.yandex-map-container {
  @apply w-full;
  height: 500px;
}
</style>
